import React from 'react';
import { Detail } from './components/FormControls';
import { PremioGanho } from './api';
import { formatCurrency } from './utils';

export const SuccessScreen = ({
  form,
  valorTotal,
  premios,
  onNew
}: {
  form: { nomeCompleto: string; telefoneMae: string; gratuito?: boolean };
  valorTotal: number;
  premios?: PremioGanho[];
  onNew: () => void;
}) => (
  <div className="success-overlay">
    <div className="success-container">
      <div className="success-animation"><div className="checkmark-circle"><div className="checkmark" /></div></div>
      <div className="success-content">
        {/* Quem foi sorteado descobre aqui, ao abrir a propria pagina */}
        {premios && premios.length > 0 && (
          <div className="premio-banner">
            <span className="premio-banner-emoji" role="img" aria-label="Troféu">🏆</span>
            <strong className="premio-banner-titulo">
              {premios.length === 1 ? 'Você foi sorteado!' : 'Você foi sorteado em mais de um sorteio!'}
            </strong>
            {premios.map((premio) => (
              <div className="premio-banner-item" key={premio.sorteioId}>
                <small>{premio.titulo}</small>
                <strong>{premio.premio}</strong>
              </div>
            ))}
            <p className="premio-banner-aviso">Procure a organização da colônia para retirar o prêmio.</p>
          </div>
        )}

        <h1 className="success-title">Pagamento Realizado com Sucesso!</h1>
        <p className="success-subtitle">Sua inscrição foi processada e você receberá um e-mail de confirmação em breve.</p>
        <div className="success-details">
          <Detail label="Participante" value={form.nomeCompleto} />
          <Detail label="Valor Pago" value={form.gratuito ? '🎉 GRATUITO' : formatCurrency(valorTotal)} />
          <Detail label="Contato" value={form.telefoneMae} />
        </div>
        <div className="success-actions">
          <a
            className="btn-whatsapp-group"
            href="https://chat.whatsapp.com/Luno3tfPJi54Mv8KrLGw3a"
            target="_blank"
            rel="noopener noreferrer"
          >
            Entrar no grupo
          </a>
          <button type="button" className="btn-new-registration" onClick={onNew}>Nova Inscrição</button>
        </div>
        <div className="success-footer">
          <p>Obrigado por escolher nossa Colônia de Férias!</p>
          <p>Seu filho(a) viverá momentos inesquecíveis conosco.</p>
        </div>
      </div>
    </div>
  </div>
);
